import { render, staticRenderFns } from "./TechDashboard.vue?vue&type=template&id=b98056d2"
import script from "./TechDashboard.vue?vue&type=script&lang=js"
export * from "./TechDashboard.vue?vue&type=script&lang=js"
import style0 from "./TechDashboard.vue?vue&type=style&index=0&id=b98056d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports